// theirs
import styled from 'styled-components'
// ours
import { TextAtTheTopOfImageProps } from '.'
import { breakpoints, color, typography } from '../../../styles'
import { appendLocationSingle } from '../../../utils/append-location'

export const textAtTheTopOfImageBaseClass = 'text-at-the-top-of-image'

export const StyledTextAtTheTopOfImage = styled.div<TextAtTheTopOfImageProps>`
    &.${textAtTheTopOfImageBaseClass} {
        background-image: url(${(props) =>
            appendLocationSingle(
                'images',
                props.content.contentBackgroundImageSource
            )});
        background-repeat: no-repeat;
        background-size: cover;
        padding: 0;
        margin: 0;
        position: relative;
        height: 100%;
        width: 100%;
        display: table;
        background-position: top left;
        animation: animatedBackground 30s linear infinite alternate;

        @keyframes animatedBackground {
            from {
                background-position: 50% 50%;
            }
            to {
                background-position: 0% 50%;
            }
        }

		.content-outer {
			display: table-cell;
			vertical-align: middle;
			text-align: center;
			position: relative;
		}

		.content-mask {
			width: 100%;
			height: 100%;
			position: absolute;
			opacity: 1;
			div {
				background-repeat: no-repeat;
				background-size: cover;
				padding: 0;
				margin: 0;
				position: relative;
				position: absolute;
				opacity 1;
				height: 100%;
				width: 100%;
				display: table;
				background-position: top left;
				animation: animatedBackground 30s linear infinite alternate;

			}
			.mask-0{
				background-color: #f7f6f3;
			}
			.mask-1 {
				background-image: url(${(props) =>
                    appendLocationSingle(
                        'images',
                        props.content.contentBackgroundStaggeredMask1Source
                    )});
			}
			.mask-2 {
				background-image: url(${(props) =>
                    appendLocationSingle(
                        'images',
                        props.content.contentBackgroundStaggeredMask2Source
                    )});
			}
			.mask-3 {
				background-image: url(${(props) =>
                    appendLocationSingle(
                        'images',
                        props.content.contentBackgroundStaggeredMask3Source
                    )});
			}
		}

		.content-inner {
			max-width: 300px;
			margin: 0 auto;

			@media (min-width: ${breakpoints.xs}) {
				max-width: 350px;
			}

			@media (min-width: ${breakpoints.sm}) {
				max-width: 550px;
			}
		}

		.text-wrapper {
			margin-bottom: 2.5rem;
			padding: 0 1rem;

			@media (min-width: ${breakpoints.lg}) {
				padding: 0;
			}

			p {
				font-weight: normal;
				font-stretch: normal;
				font-style: normal;
				line-height: 1.64;
				letter-spacing: 0.88px;
				text-align: ${(props) =>
                    props.content.contentTextInnerAlignment?.toLocaleLowerCase()};
				color: ${color.raisinblack};

				font-size: ${typography.size.s2};
				@media (min-width: ${breakpoints.xs}) {
					font-size: ${typography.size.s3}
				}
			}
		}

		picture img {
			height: auto;
			width: 245px;
			margin: 0 auto;

			@media (min-width: ${breakpoints.xs}) {
				width: 300px;
			}

			@media (min-width: ${breakpoints.sm}) {
				width: 330px;
			}

			@media (min-width: ${breakpoints.lg}) {
				height: 241.875px;
				width: 430px;
			}
		}
    }
`
